import { breakpoints, Logo, useWindowSize } from '@bphxd/ds-core-react';
import { Down24, Support24 } from '@bphxd/ds-core-react/lib/icons';
import { useState } from 'react';
import { Navbar, NavbarBrand, Nav, NavItem, NavLink, Offcanvas, Container } from 'reactstrap';
import { FCC } from '../../lib/types';
import AssetSelection from '../organisms/AssetSelection/AssetSelection';
import ProfileAvatar from '../organisms/ProfileAvatar/ProfileAvatar';
import NoticeBarProvider from '../molecules/NoticeBar/NoticeBar';
import classes from './TabletLayout.module.scss';
import TabletBreadcrumbs from './TabletBreadcrumbs';
import { GET_SUPPORT_TEAM_EMAILS } from '../../graph-queries/common/config';
import { useQuery } from '@apollo/client';

const TabletLayout: FCC = ({ children }) => {
  const [isSearchOpen, setSearchIsOpen] = useState(false);
  const breakpoint = 'md';
  const { width } = useWindowSize();
  const toggleSearch = () => {
    setSearchIsOpen(!isSearchOpen);
  };
  const { data: users } = useQuery(GET_SUPPORT_TEAM_EMAILS);

  const renderAssetSelection = <AssetSelection />;

  const launchTeams = (supportTeamEmails: string) => {
    const chatUrl = `https://teams.microsoft.com/l/chat/0/0?users=${encodeURIComponent(supportTeamEmails)}`;
    return window.open(chatUrl, '_blank');
  };

  return (
    <div className={classes.root}>
      <Navbar expand className="navbar-border" sticky="top">
        <div className="d-flex align-items-center">
          <NavbarBrand href={`/`}>
            <Logo className="mx-n3" />
            <span className="ms-5">Digital Twin Companion App</span>
          </NavbarBrand>
        </div>

        {/* right side */}
        <Nav navbar className={`flex-grow-1 me-4`}>
          <NavItem
            className={`d-none d-${breakpoint}-flex flex-grow-1 me-4 justify-content-center align-items-center`}
          ></NavItem>
          <NavItem className={`d-none d-${breakpoint}-flex me-4`}>{renderAssetSelection}</NavItem>
          <NavItem className={`d-${breakpoint}-none`}>
            <NavLink href="#" onClick={toggleSearch} active={isSearchOpen}>
              <span>
                <Down24 />
              </span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink style={{ cursor: 'pointer' }}>
              <span>
                <Support24 onClick={() => launchTeams(users?.supportTeamEmails || '')} />
              </span>
            </NavLink>
          </NavItem>
        </Nav>
        <ProfileAvatar />
      </Navbar>

      {width < breakpoints[breakpoint] && (
        <>
          <Offcanvas
            direction="top"
            isOpen={isSearchOpen}
            toggle={toggleSearch}
            className="offcanvas-sidebar pt-11"
            backdropClassName="offcanvas-backdrop-sidebar"
            style={{ height: '150px' }}
            zIndex="auto"
          >
            <div className="px-4 py-3">{renderAssetSelection}</div>
          </Offcanvas>
        </>
      )}

      <div className={classes.content}>
        <NoticeBarProvider>
          <Container>
            <TabletBreadcrumbs />
            {children}
          </Container>
        </NoticeBarProvider>
      </div>
    </div>
  );
};

export default TabletLayout;
